__turbopack_context__.v({
  "text-area-box": "tzKqaW_text-area-box",
  "text-area-input": "tzKqaW_text-area-input",
});
